import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wfh',
  templateUrl: './wfh.component.html',
  styleUrls: ['./wfh.component.css']
})
export class WfhComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
